import {addSlug} from 'shared';
import {z} from 'zod';

export const checklistTemplateSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    modified: z.coerce.date(),
    sections: z
      .object({
        // id: z.string(),
        identifier: z.number().nonnegative().int(),
        title: z.string().min(1),
        items: z
          .object({
            // id: z.string(),
            identifier: z.number().nonnegative().int(),
            description: z.string().min(1),
          })
          .array()
          .min(1),
      })
      .array()
      .nonempty(),
  })
  .transform(addSlug);

export const checklistTemplatePayloadSchema = z.object({
  name: z.string().trim().min(2).max(30),
  sections: z
    .object({
      title: z.string().min(1),
      items: z
        .object({
          description: z.string().min(1),
        })
        .array()
        .min(1),
    })
    .array()
    .min(1),
});
